import { AxiosRequestConfig } from 'axios';
import XLRLogger from 'src/common/helpers/logger';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { emeraldRequest } from '../../common/api/emerald-request';
import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import { LocalStorage } from '../../common/helpers/local-storage';
import { EmeraldRequestParams } from '../../common/interfaces/requests/EmeraldRequestParams';
import { store } from '../../common/redux/configure-store';
import { EndOfDayActions } from '../../common/redux/reducers/end-of-day-reducer';
import { signOff } from '../../login/business-logic/sign-off';
import { showEndOfDayDialog } from '../end-of-day';
import { showEndOfDayManualApprovalDialog } from '../end-of-day-manual-approval';

export const getEndOfDayStatus = async (): Promise<void> => {
  const lockoutUser = LocalStorage.getLockUser();
  const userName = store.getState().user.userName;
  const isCashierAvailable: boolean = !!userName && !lockoutUser;

  await getEodStatus()
    .then((endOfDayStatus: IEndOfDayStatus): void => {
      const endofDayActivity = endOfDayStatus.activity;
      if (endOfDayStatus.shouldExecute && isCashierAvailable) {
        if (endOfDayStatus.userNotAllowedToExecuteActivities) {
          const messageItem: IMessageModal = {
            message: 'EndOfDay_Caption',
            type: EmeraldDialogTypes.Info,
            subMessage: 'EodForceSignOff_Message',
            onAccept: signOff,
            acceptButtonLabel: 'SignOff',
          };
          popupMessage(messageItem);
        } else if (endOfDayStatus.activity?.length && endofDayActivity) {
          const messageItem: IMessageModal = {
            message: 'EndOfDay_Caption',
            type: EmeraldDialogTypes.Info,
            subMessage: 'EndOfDayActivitiesStart_DidNotStartMessage',
            onAccept: () => store.dispatch(EndOfDayActions.setActivity(endofDayActivity)),
          };
          popupMessage(messageItem);
        } else {
          if (endOfDayStatus.manualApproval) {
            showEndOfDayManualApprovalDialog();
          } else {
            showEndOfDayDialog();
          }
        }
      }
    })
    .catch(err => {
      XLRLogger.error({
        message: 'Get EOD status error',
        source: 'end-of-day-stauts.ts',
        data: err,
      });
    });
};

export interface IEndOfDayStatus {
  shouldExecute: boolean;
  manualApproval: boolean;
  activity?: IActivity[];
  userNotAllowedToExecuteActivities?: boolean;
}
export interface IEndOfDay {
  activity: IActivity[];
}

export interface IActivity {
  name: string;
  priority: number;
  isCompleted: boolean;
}

export enum ExecutionTiming {
  Immediate = 'Immediate',
  PostponeMax = 'PostponeMax',
}
export enum EndOfDayActivityName {
  TenderPickUp = 'Tender Pickup',
  TillDeclaration = 'Till Declaration',
}

const getEodStatus = async (): Promise<IEndOfDayStatus> => {
  const axiosConfig: AxiosRequestConfig = {
    url: '/end-of-day/status',
    method: 'GET',
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  const endOfDaySatus = await emeraldRequest<IEndOfDayStatus>(emeraldRequestParams);
  return endOfDaySatus;
};
